import React from 'react';
import { useIntl } from 'react-intl';

import { useSettings } from 'app/main/components';
import DetailsSectionStatsTable, {
	type DetailsSectionStatsTableColumnType
} from 'app/main/modules/components/DetailsSectionStatsTable';

interface ProjectsDetailsSectionStatsWorkReportsProps {
	stats: any[];
}

export default function ProjectsDetailsSectionStatsWorkReports(props: ProjectsDetailsSectionStatsWorkReportsProps) {
	const { sysSettings, t } = useSettings();
	const intl = useIntl();

	const canShowFinancialStats = sysSettings.projects_show_financial_stats === 'true';

	const typeColumn: DetailsSectionStatsTableColumnType = {
		header: t('PROJ_SECTION_WORKREPORTS_STATS_COLUMN_TYPE'),
		valueFormatter: stat => stat.wore_type
	};

	const columns: DetailsSectionStatsTableColumnType[] = [
		{
			header: t('PROJ_SECTION_WORKREPORTS_STATS_COLUMN_HOURS_PLANNED'),
			valueFormatter: stat =>
				intl.formatMessage(
					{ id: 'detailsSectionStatsTableRow.plannedLengthHours', defaultMessage: t('DURATION_HOURS') },
					{ value: stat.wore_hours_planned || 0 }
				)
		},
		{
			header: t('PROJ_SECTION_WORKREPORTS_STATS_COLUMN_HOURS'),
			valueFormatter: stat =>
				intl.formatMessage(
					{ id: 'detailsSectionStatsTableRow.lengthHours', defaultMessage: t('DURATION_HOURS') },
					{ value: stat.wore_hours || 0 }
				)
		}
	];

	if (canShowFinancialStats) {
		columns.push({
			header: t('PROJ_SECTION_WORKREPORTS_STATS_COLUMN_EXPENSES_BILLED'),
			valueFormatter: stat =>
				intl.formatNumber(stat.wore_expenses_hours || 0, { style: 'currency', currency: 'EUR' })
		});
	}

	return (
		<DetailsSectionStatsTable
			title={t('PROJ_SECTION_WORKREPORTS_STATS_TITLE')}
			typeColumn={typeColumn}
			columns={columns}
			stats={props.stats}
		/>
	);
}
